import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingContact from "@/components/feature/FloatingContact";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import GoldStatsBar from "./components/GoldStatsBar";
import WarehouseSection from "./components/WarehouseSection";
import FreightSection from "./components/FreightSection";
import BuyerQuoteSection from "./components/BuyerQuoteSection";
import SocialStarsSection from "./components/SocialStarsSection";
import TrustSection from "./components/TrustSection";
import TopVendors from "./components/TopVendors";
import FactoryMarketplace from "./components/FactoryMarketplace";
import SpecialFactorySection from "./components/SpecialFactorySection";
import BulkOrderSection from "./components/BulkOrderSection";
import InstallAppSection from "./components/InstallAppSection";
import { useSEO, SITE_URL } from "@/hooks/useSEO";

export default function HomePage() {
  useSEO({
    title: "Crown Global Factory & Buyer Platform | Buy Containers Direct from Factories",
    description: "Crown Global Factory and Buyer — the best global trade platform. Tens of millions of buyers purchase containers directly from verified factories worldwide. Source bulk products, connect with manufacturers, and trade globally.",
    keywords: "factory direct, bulk container orders, global trade platform, buy from factory, wholesale manufacturer, Crown Global",
    canonical: "/",
    ogTitle: "Crown Global Factory & Buyer Platform",
    ogDescription: "Tens of millions of buyers purchase containers directly from factories. The best factory-to-buyer global trade platform.",
    ogImage: "https://public.readdy.ai/ai/img_res/c2709c1283b7effd5be5b17a3173c628.jpg",
    schemaJson: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          "@id": `${SITE_URL}/#website`,
          "url": SITE_URL,
          "name": "Crown Global Factory & Buyer Platform",
          "description": "The best global trade platform connecting factories and buyers worldwide for bulk container orders.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": `${SITE_URL}/marketplace?q={search_term_string}`
            },
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@type": "Organization",
          "@id": `${SITE_URL}/#organization`,
          "name": "Crown Global Factory & Buyer",
          "url": SITE_URL,
          "logo": {
            "@type": "ImageObject",
            "url": "https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg",
            "width": 200,
            "height": 200
          },
          "sameAs": [],
          "description": "Crown Global Factory and Buyer is the world's leading factory-to-buyer trade platform, connecting verified manufacturers with global buyers for bulk container orders.",
          "areaServed": "Worldwide",
          "numberOfEmployees": { "@type": "QuantitativeValue", "value": 500 },
          "foundingDate": "2020",
          "serviceType": ["Global Trade Platform", "Factory Direct Sourcing", "Bulk Container Orders", "Freight Services", "Overseas Warehousing"]
        },
        {
          "@type": "WebPage",
          "@id": `${SITE_URL}/#webpage`,
          "url": SITE_URL,
          "name": "Crown Global Factory & Buyer Platform | Buy Containers Direct from Factories",
          "description": "Crown Global Factory and Buyer — the best global trade platform. Tens of millions of buyers purchase containers directly from verified factories worldwide.",
          "isPartOf": { "@id": `${SITE_URL}/#website` },
          "about": { "@id": `${SITE_URL}/#organization` },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL }
            ]
          }
        }
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white pb-16 md:pb-0">
      <Navbar />
      <HeroSection />
      <GoldStatsBar />
      <StatsBar />
      <FactoryMarketplace />
      <SpecialFactorySection />
      <BulkOrderSection />
      <TopVendors />
      <WarehouseSection />
      <FreightSection />
      <BuyerQuoteSection />
      <SocialStarsSection />
      <TrustSection />
      <InstallAppSection />
      <Footer />
      <FloatingContact />
    </div>
  );
}
